import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

export default function CareGuide() {
  const steps = [
    { icon: "FiDroplet", title: "Hand Wash Only", desc: "Never put professional knives or pans in the dishwasher. Warm water and mild soap." },
    { icon: "FiWind", title: "Dry Immediately", desc: "Use a clean towel to dry thoroughly right after washing to prevent spotting or rust." },
    { icon: "FiEdit2", title: "Regular Honing", desc: "Hone your blade before every heavy prep session to keep the edge aligned." },
    { icon: "FiShield", title: "Proper Storage", desc: "Use a magnetic strip, block, or sheath. Never throw loose in a drawer." }
  ];

  return (
    <section id="care" className="py-24 bg-zinc-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="md:w-1/2">
            <img 
              src="https://images.unsplash.com/photo-1574768397368-43d7890cc38a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
              alt="Knife Maintenance" 
              className="rounded-sm shadow-xl"
            />
          </div>
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold text-zinc-800 mb-6">Built to Last Generations</h2>
            <p className="text-zinc-600 mb-8 text-lg">With the right care, Forge & Fork tools will become family heirlooms. Here is how to keep them performing at their peak.</p>
            
            <div className="space-y-6">
              {steps.map((step, i) => (
                <motion.div 
                  key={i}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.1 }}
                  className="flex gap-4"
                >
                  <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shrink-0 shadow-sm border border-zinc-200">
                    <SafeIcon icon={step.icon} className="text-red-500 text-xl" />
                  </div>
                  <div>
                    <h4 className="font-bold text-zinc-800">{step.title}</h4>
                    <p className="text-zinc-600 text-sm">{step.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}